export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53')
];

export const server_loads = [0,2,4,9];

export const dictionary = {
		"/(marketing)": [37,[6]],
		"/(admin)/account/(menu)": [10,[2,3]],
		"/(admin)/account/api": [20,[2]],
		"/(admin)/account/app/dashboard": [21,[2]],
		"/(admin)/account/app/interviews": [22,[2,4]],
		"/(admin)/account/app/interviews/ai-coach": [23,[2,4]],
		"/(admin)/account/app/interviews/ai-coach/feedback": [24,[2,4]],
		"/(admin)/account/app/interviews/ai-coach/progression": [25,[2,4]],
		"/(admin)/account/app/interviews/categories": [26,[2,4]],
		"/(admin)/account/app/interviews/immediate": [27,[2,4,5]],
		"/(admin)/account/app/interviews/immediate/[callId]/feedback": [~28,[2,4,5]],
		"/(admin)/account/app/interviews/schedule": [29,[2,4]],
		"/(admin)/account/app/interviews/training": [30,[2,4]],
		"/(admin)/account/app/interviews/training/breakdown": [32,[2,4]],
		"/(admin)/account/app/interviews/training/[id]": [31,[2,4]],
		"/(admin)/account/(menu)/billing": [~11,[2,3]],
		"/(admin)/account/(menu)/billing/manage": [~12,[2,3]],
		"/(admin)/account/create_profile": [33,[2]],
		"/(admin)/account/select_plan": [34,[2]],
		"/(admin)/account/(menu)/settings": [13,[2,3]],
		"/(admin)/account/(menu)/settings/change_email_subscription": [~15,[2,3]],
		"/(admin)/account/(menu)/settings/change_email": [14,[2,3]],
		"/(admin)/account/(menu)/settings/change_password": [16,[2,3]],
		"/(admin)/account/(menu)/settings/delete_account": [17,[2,3]],
		"/(admin)/account/(menu)/settings/edit_profile": [~18,[2,3]],
		"/(admin)/account/(menu)/settings/reset_password": [19,[2,3]],
		"/(admin)/account/sign_out": [35,[2]],
		"/(admin)/account/subscribe/[slug]": [~36,[2]],
		"/(marketing)/blog": [38,[6,7]],
		"/(marketing)/blog/(posts)/awesome_post": [39,[6,7,8]],
		"/(marketing)/blog/(posts)/example_blog_post": [40,[6,7,8]],
		"/(marketing)/blog/(posts)/how_we_built_our_41kb_saas_website": [41,[6,7,8]],
		"/(marketing)/contact_us": [42,[6]],
		"/(marketing)/cookies": [~43,[6]],
		"/(marketing)/login": [44,[6,9]],
		"/(marketing)/login/current_password_error": [45,[6,9]],
		"/(marketing)/login/forgot_password": [46,[6,9]],
		"/(marketing)/login/sign_in": [47,[6,9]],
		"/(marketing)/login/sign_up": [48,[6,9]],
		"/(marketing)/pricing": [49,[6]],
		"/(marketing)/privacy": [~50,[6]],
		"/(marketing)/search": [51,[6]],
		"/(marketing)/support": [~52,[6]],
		"/(marketing)/terms": [~53,[6]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';